import React, {Component} from 'react'
import ERegistry from './ERegistry'

export default class Wrapper extends Component {
  render() {
    return (
      <ERegistry />
    )
  }
}